(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benlee-athlete-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bl-athlete-slider')) {
    class BlAthleteSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-athletes-track]');
        this.prevBtn = this.querySelector('[data-athletes-prev]');
        this.nextBtn = this.querySelector('[data-athletes-next]');
        this.dots = Array.from(this.querySelectorAll('[data-athletes-dot]'));
        this.slides = this.track
          ? Array.from(this.track.querySelectorAll('[data-athletes-slide]'))
          : [];

        if (!this.track || this.slides.length < 2) {
          this.classList.add('bl-athletes--static');
          return;
        }

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.onScroll = this.sync.bind(this);
        this.onPrev = () => this.goBy(-1);
        this.onNext = () => this.goBy(1);
        this.onDot = (event) => {
          const index = Number(event.currentTarget.dataset.index);
          if (!Number.isNaN(index)) this.goTo(index);
        };
        this.onKey = (event) => {
          if (event.key === 'ArrowLeft') this.goBy(-1);
          if (event.key === 'ArrowRight') this.goBy(1);
        };
        this.onBlockSelect = (event) => {
          const slide = event.target.closest('[data-athletes-slide]');
          if (!slide || !this.contains(slide)) return;
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.goTo(index);
        };

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prevBtn?.addEventListener('click', this.onPrev);
        this.nextBtn?.addEventListener('click', this.onNext);
        this.dots.forEach((dot) => dot.addEventListener('click', this.onDot));
        this.addEventListener('keydown', this.onKey);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.resizeObserver = new ResizeObserver(() => this.sync());
        this.resizeObserver.observe(this.track);
        this.sync();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.prevBtn?.removeEventListener('click', this.onPrev);
        this.nextBtn?.removeEventListener('click', this.onNext);
        this.dots.forEach((dot) => dot.removeEventListener('click', this.onDot));
        this.removeEventListener('keydown', this.onKey);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
      }

      slideOffset() {
        if (this.slides.length < 2) return this.slides[0]?.offsetWidth || 0;
        return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
      }

      currentIndex() {
        const offset = this.slideOffset();
        if (offset <= 0) return 0;
        return Math.round(this.track.scrollLeft / offset);
      }

      maxIndex() {
        const offset = this.slideOffset();
        if (offset <= 0) return 0;
        return Math.max(0, Math.round((this.track.scrollWidth - this.track.clientWidth) / offset));
      }

      goBy(step) {
        this.goTo(this.currentIndex() + step);
      }

      goTo(index) {
        const offset = this.slideOffset();
        const next = Math.max(0, Math.min(index, this.maxIndex()));
        this.track.scrollTo({
          left: next * offset,
          behavior: this.reduceMotion ? 'auto' : 'smooth',
        });
      }

      sync() {
        const overflowing = this.track.scrollWidth > this.track.clientWidth + 2;
        this.classList.toggle('bl-athletes--static', !overflowing);

        const index = this.currentIndex();
        const atStart = this.track.scrollLeft <= 2;
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;

        if (this.prevBtn) this.prevBtn.disabled = atStart;
        if (this.nextBtn) this.nextBtn.disabled = atEnd;

        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('bl-athlete-slider', BlAthleteSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benlee-hero-timer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bl-timer-hero')) {
    class BlTimerHero extends HTMLElement {
      connectedCallback() {
        this.cta = this.querySelector('[data-timer-cta]');
        this.ctaLabel = this.querySelector('[data-timer-label]');
        this.status = this.querySelector('[data-timer-status]');
        this.sub = this.querySelector('[data-timer-sub]');
        this.lockIcon = this.querySelector('[data-icon-lock]');
        this.goIcon = this.querySelector('[data-icon-go]');
        this.liveRegion = this.querySelector('[data-timer-live]');
        this.units = {
          days: this.querySelector('[data-unit="days"]'),
          hours: this.querySelector('[data-unit="hours"]'),
          minutes: this.querySelector('[data-unit="minutes"]'),
          seconds: this.querySelector('[data-unit="seconds"]'),
        };

        this.endAt = Number(this.dataset.end) * 1000;
        this.live = false;
        this.onCtaClick = this.#onCtaClick.bind(this);
        this.onVisibility = this.#onVisibility.bind(this);

        this.cta?.addEventListener('click', this.onCtaClick);
        document.addEventListener('visibilitychange', this.onVisibility);

        this.#tick();
      }

      disconnectedCallback() {
        this.cta?.removeEventListener('click', this.onCtaClick);
        document.removeEventListener('visibilitychange', this.onVisibility);
        window.clearTimeout(this.timerId);
      }

      #onCtaClick(event) {
        if (this.classList.contains('is-locked') || this.cta?.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
        }
      }

      #onVisibility() {
        if (document.visibilityState === 'visible') this.#tick();
      }

      #pad(value) {
        return String(Math.max(0, value)).padStart(2, '0');
      }

      #remaining() {
        if (!this.endAt) return 0;
        return Math.max(0, this.endAt - Date.now());
      }

      #render(ms) {
        const total = Math.floor(ms / 1000);
        const days = Math.floor(total / 86400);
        const hours = Math.floor((total % 86400) / 3600);
        const minutes = Math.floor((total % 3600) / 60);
        const seconds = total % 60;

        if (this.units.days) this.units.days.textContent = this.#pad(days);
        if (this.units.hours) this.units.hours.textContent = this.#pad(hours);
        if (this.units.minutes) this.units.minutes.textContent = this.#pad(minutes);
        if (this.units.seconds) this.units.seconds.textContent = this.#pad(seconds);
      }

      #unlock() {
        if (this.live) return;
        const wasLocked = this.classList.contains('is-locked');
        this.live = true;
        this.classList.add('is-live');
        this.classList.remove('is-locked');

        if (this.status && this.dataset.statusAfter) {
          this.status.textContent = this.dataset.statusAfter;
        }
        if (this.sub && this.dataset.textAfter) {
          this.sub.textContent = this.dataset.textAfter;
        }
        if (this.ctaLabel) {
          this.ctaLabel.textContent = this.dataset.labelAfter || this.dataset.labelBefore || this.ctaLabel.textContent;
        }
        if (this.lockIcon) this.lockIcon.hidden = true;
        if (this.goIcon) this.goIcon.hidden = false;

        if (this.cta) {
          this.cta.removeAttribute('aria-disabled');
          this.cta.removeAttribute('tabindex');
          this.cta.removeAttribute('disabled');
          if (this.cta.dataset.href) this.cta.setAttribute('href', this.cta.dataset.href);
        }

        if (wasLocked && this.liveRegion && this.dataset.liveAnnounce) {
          this.liveRegion.textContent = '';
          requestAnimationFrame(() => {
            this.liveRegion.textContent = this.dataset.liveAnnounce;
          });
        }
      }

      #tick() {
        window.clearTimeout(this.timerId);
        const remaining = this.#remaining();
        this.#render(remaining);

        if (remaining <= 0) {
          this.#unlock();
          return;
        }

        this.timerId = window.setTimeout(() => this.#tick(), 250);
      }
    }

    customElements.define('bl-timer-hero', BlTimerHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
